<script>
import Breadcrumbs from "../components/Breadcrumbs.svelte";
import Sidebar from "../components/product-list/Sidebar.svelte";
import Sort from "../components/product-list/Sort.svelte";
import Footer from "../components/Footer.svelte";
import HeaderSignedIn from "../components/header/HeaderSignedIn.svelte";
import Item from "../components/product-list/Item.svelte";
import ItemSignedIn from "../components/product-list/ItemSignedIn.svelte";
import Modals from "../components/Modals.svelte";
import TopbarSignedIn from "../components/TopbarSignedIn.svelte";
import Pagination from "../components/product-list/Pagination.svelte";
import NewItem from "../components/product-list/NewItem.svelte";

let elslutbleck = {
  title: "Elslutbleck ES19 12/24V Rättvänd",
  picture:
    "https://shopgib.gothes.se/public/images/ftg10/img320x320/152090_17971.jg",
  info: {
    article: "152090",
    brand: "Safetron",
    surface: "Rostfri",
  },
};
let elslutbleck2 = {
  title: "HÖGHÅLLSFASTHETSSKRUV 80MM",
  picture:
    "https://shopgib.gothes.se/public/images/ftg10/img320x320/152090_17971.jpg",
  info: {
    article: "152093",
    brand: "Safetron",
    surface: "Rostfri",
  },
};
let dörrstängarhus = {
  title: "Dörrstängarhus TS73 EN 4 Silver",
  picture:
    "https://shopgib.gothes.se/public/images/ftg10/img320x320/102059.jpg",
  info: {
    article: "37010101",
    brand: "Safetron",
    surface: "Rostfri",
  },
};
</script>

<div class="container" id="wrapper" data-event="productImpression">
  <TopbarSignedIn />
  <HeaderSignedIn />
  <div class="row">
    <div class="col-xs-12">
      <div class="row fill-white">
        <div class="col-xs-12 col-sm-12  primary-column pb-lg">
          <div id="content" class="main-content">
            <style>
            .search-highlight {
              background-color: #c4f3f7;
            }
            </style>
            <div class="row">
              <div class="col-xs-12">
                <Breadcrumbs />

                <div class="padd hidden">
                  <div class="info"></div>
                </div>

                <div class="row">
                  <Sidebar />
                  <div class="col-xs-12 col-md-9 pt-sm">
                    <h2 class="hidden-xs hidden-sm mt-none">Elslutbleck</h2>

                    <Sort />

                    <div class="product-search-result">
                      <div
                        id="searchspinner"
                        class="text-center pt-md pb-md absolute"
                        style="width: 100%;"
                      >
                        <i
                          class="fa fa-refresh fa-spin muted absolute"
                          style="left: 50%;"
                        ></i>
                      </div>
                      <NewItem item="{elslutbleck}" />
                      <NewItem item="{elslutbleck2}" />
                      <NewItem item="{dörrstängarhus}" />
                      <script>
                      setTimeout(function () {
                        var spinner = document.getElementById("searchspinner");
                        if (spinner) {
                          spinner.className = spinner.className + " hidden";
                        }
                      }, 1);
                      </script>
                    </div>

                    <div class="row mt-sm">
                      <div class="col-xs-12">
                        <Pagination />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="modal fade"
              id="shoppingListModal"
              data-aid=""
              tabindex="-1"
              role="dialog"
              aria-labelledby="myModalLabel"
            >
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    ><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="myModalLabel">
                      Lägg till i produktlista
                    </h4>
                  </div>
                  <div class="modal-body inner">...</div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-default"
                      data-dismiss="modal"
                    >Stäng</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- </div> -->

<Modals />
<Footer />
